const truediv = (a, b) => a / b;
export default truediv;
